module.exports = __webpack_public_path__ + "RobotoRegular.8f937d6cda6df05cdd1e.eot";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoRegular.eot
// module id = ../../../../../src/fonts/RobotoRegular.eot
// module chunks = 3